import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ScheduledMeetings from "./meetings";
import { getMeetingList } from "services/redux/brandActivtion/meetings/action";

const mapStateToProps = (state) => ({
  meetingList: state.baMeetingReducer.meetingList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getMeetingList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ScheduledMeetings);
